import { Button, Dropdown, Space } from "antd";
import { ChevronDown, FileSpreadsheet, FileText } from "lucide-react";

type AuditExportSplitButtonProps = {
	onExportCSV: () => void;
	onExportPDF: () => void;
};

/**
 * Header export control for Technical Audit issues.
 * Space.Compact + antd Button/Dropdown keeps CSV, the caret, and the
 * neighboring header actions on the same 32px control height.
 */
export function AuditExportSplitButton({
	onExportCSV,
	onExportPDF,
}: AuditExportSplitButtonProps) {
	return (
		<Space.Compact>
			<Button
				icon={<FileSpreadsheet className="w-4 h-4" />}
				onClick={onExportCSV}
			>
				CSV
			</Button>
			<Dropdown
				trigger={["click"]}
				placement="bottomRight"
				menu={{
					items: [
						{
							key: "csv",
							icon: <FileSpreadsheet className="w-4 h-4" />,
							label: "Export as CSV",
							onClick: onExportCSV,
						},
						{
							key: "pdf",
							icon: <FileText className="w-4 h-4" />,
							label: "Export as PDF",
							onClick: onExportPDF,
						},
					],
				}}
			>
				<Button
					icon={<ChevronDown className="w-4 h-4" />}
					aria-label="Export format options"
				/>
			</Dropdown>
		</Space.Compact>
	);
}
